import React from "react";
import Pagination from "./Pagination";

const SubscribeTable = ({ data, currentPage, totalPages, onPageChange }) => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-gray-700 text-white rounded-lg">
        <thead>
          <tr className="text-left border-b border-gray-600">
            <th className="px-4 py-3">#</th>
            <th className="px-4 py-3">Email</th>
            <th className="px-4 py-3">Subscribed Date</th>
            <th className="px-4 py-3">Status</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <tr
                key={item._id || index}
                className="border-b border-gray-600 hover:bg-gray-600 transition"
              >
                <td className="px-4 py-3">
                  {(currentPage - 1) * 10 + index + 1}
                </td>
                <td className="px-4 py-3">{item.email}</td>
                <td className="px-4 py-3">
                  {new Date(item.subscribedAt || item.createdAt).toLocaleDateString()}
                </td>
                <td className="px-4 py-3">
                  <span className="p-2 rounded bg-green-500 text-white">
                    Active
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className="text-center py-4">
                No subscribers found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="mt-4 flex justify-center">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default SubscribeTable;